import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rSorguInputlari, rValue } from '../../models/.catalog';

export default class SorguInputlariApi extends ApiBase<pList, rValue<rSorguInputlari>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/SorguInputlari',
      }),
      options
    );
  }
}
